import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_USERS } from "../domain";

import { usersApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_ACCEPT_TERMS_AND_CONDITIONS = "ACCEPT_TERMS_AND_CONDITIONS";

const allowedRoles = [
  UserRole.Owner,
  UserRole.Manager,
  UserRole.Respondent,
  UserRole.Viewer,
  UserRole.Auditor,
];

const acceptTermsAndConditions = async (): Promise<void> => {
  const response = await usersApi.usersControllerAcceptTermsAndConditions();

  return response.data;
};

export const useAcceptTermsAndConditions = (
  user: UserProfileDto | null,
): {
  acceptTermsAndConditions: () => void;
  acceptTermsAndConditionsAsync: () => Promise<void>;
  acceptTermsAndConditionsEnabled: boolean;
  acceptTermsAndConditionsError: Error | null;
  isSuccessAcceptTermsAndConditions: boolean;
  isPendingAcceptTermsAndConditions: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isSuccess, isPending, error } = useMutation({
    mutationKey: [DOMAIN_USERS, ACTION_ACCEPT_TERMS_AND_CONDITIONS],
    mutationFn: enabled ? acceptTermsAndConditions : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_USERS] });
    },
  });

  return {
    acceptTermsAndConditions: mutate,
    acceptTermsAndConditionsAsync: mutateAsync,
    acceptTermsAndConditionsEnabled: enabled,
    acceptTermsAndConditionsError: error,
    isSuccessAcceptTermsAndConditions: isSuccess,
    isPendingAcceptTermsAndConditions: isPending,
  };
};
